import styled from 'styled-components';

export const StSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  border: none;
  :hover {
    cursor: pointer;
  }
  background-color: white;
`;

export const StFlagIcon = styled.img`
  height: 20px;
  width: 20px;
`;

export const StSwitchText = styled.p`
  font-size: 15px;
  font-height: bold;
  margin: 0px 0px 0px 10px;
`;
